import { render, staticRenderFns } from "./roomForm.vue?vue&type=template&id=51716bbc&"
import script from "./roomForm.vue?vue&type=script&lang=js&"
export * from "./roomForm.vue?vue&type=script&lang=js&"
import style0 from "./roomForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports